import styled, {ThemeProps} from 'styled-components';
import Image from '@stencil/image';
import {Theme} from './../../../../theme/types';
import {Row} from './../../common/Layouts/Layouts';

export const ReviewByUserWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  padding: ${props.theme.spacing.xlarge};
  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
`,
);

export const AllReviewWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-top:${props.theme.spacing.xlarge};
  width:100%;
  background-color: ${props.theme.colors.goBrandBlue.light};
  border-radius: ${props.theme.misc.borderRadius.large};

`,
);

export const AllReviewBtnDiv = styled.a(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  padding-top:${props.theme.spacing.xxlarge};
  padding-bottom:${props.theme.spacing.xxlarge};

  justify-content: center;
  cursor: pointer;
  text-decoration: none;

`,
);

export const SeeAllLink = styled.a(
  props => `
  display:inline-flex;
  cursor: pointer;
  font-size:${props.theme.font.large};
  padding-right:${props.theme.spacing.base};
  font-family:${props.theme.font.fontFamily};
  font-weight:bold;

  color: ${props.theme.colors.goBrandBlue.base};
  &:hover{
    color: ${props.theme.colors.goBrandBlue.base};
  }
`,
);

export const TripAdvisorImage = styled(Image)(
  props => `
    display: flex;
    width: 14.5rem
    height: 2.2rem;

`,
);
